module.exports = __webpack_public_path__ + "img/hot_icon.3c9e86b6.svg";